export const FEED_NOT_SUPPORTED_LANGS = ['ru', 'fi', 'ua', 'cn', 'bg', 'hr', 'gr', 'tr', 'pt', 'sk'];
export const GOOGLE_TRANSLATE_URL = 'https://translation.googleapis.com/language/translate/v2';
export const GOOGLE_TRANSLATE_API_KEY = 'AIzaSyCm0QRXDC4j68bhYr125ep72APNJiXcH1w';
export const MAX_UPLOAD_FILE_SIZE = 5242880; // 5MB
export const MAX_COMMENT_ATTACHMENTS_TO_UPLOAD = 5;
export const IMAGES_UPLOAD_MIME_TYPES = ['image/png', 'image/jpeg'];
export const TAGS_FOR_OIL_GAS_FINDER_RELATED_MATERIALS = [
  'acservice', 'actroubleshooting', 'acbestpractice', 'accompressor', 'acflushing', 'heatpump',
];
